import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { NavBar } from "../../commonComponents";
import { ErrorFallback } from "../../components/Error/Error";
import { Loading } from "../../components/Loading/Loading";
import styles from "./Marketplace.module.css";
import FleekIcon from "../../asset/icons/FleekIcon.png";
import NoSearchResult from "../../asset/images/NoSearchResult.png";
import { CustomLink } from "../../components/CustomLink/CustomLink";
import FleekCoin from "../../asset/icons/fleek-coin-logo.png";
import 'react-tooltip/dist/react-tooltip.css';

import {
  MarketPlaceCard,
  BundleMarketCard,
  SearchComp,
} from "../../components";
import Api from "../../utils/Api/Api";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import cx from "classnames";
import InfiniteScroll from "react-infinite-scroll-component";
import { ScrollMenu } from "react-horizontal-scrolling-menu";

import "react-horizontal-scrolling-menu/dist/styles.css";

import { MobileBottomNavBar } from "../../commonComponents";
import Helper from "../../utils/Helper";
import UTMTracker from "../../utils/UTMTracker";
import { Tooltip } from "react-tooltip";
import { SectionCard } from "../../components/SectionCard/SectionCard";

function Arrow() {
  return <div className={styles.hide}></div>;
}

export const Marketplace = ({ isLoggedIn }) => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [hasError, setError] = useState(false);
  const [brandImage, setBrandImage] = useState([]);
  const [bundleData, setBundleData] = useState([]);
  const [brandData, setBrandData] = useState([]);
  const [slideNumber, setSlideNumbar] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const isMobile = Helper.isMobile();
  const [showMobileSearch, setShowMobileSerach] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [sectionsList, setSectionsList] = useState([]);
  const [sectionsData, setSectionsData] = useState({});
  const [sectionsLoading, setSectionsLoading] = useState({});

  const toggleMobSearch = () => {
    setShowMobileSerach((pre_state) => !pre_state);
  };
  let settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: slideNumber,
    prevArrow: <Arrow />,
    nextArrow: <Arrow />,
    afterChange(currentSlide) {
      setSlideNumbar(currentSlide);
    },
  };

  const fetchMarketPlaceData = async (page_size = 20, searchFlow) => {
    try {
      const promiseArr = [
        Api.MarketPlaceData({
          service_name: searchValue ? searchValue : undefined,
          page: !searchFlow ? page : 1,
          digital_only: 1,
          page_size,
        }),
      ];
      if (page === 1 && !searchFlow) {
        promiseArr.push(Api.MarketPlaceBanner({ os: "web" }));
        promiseArr.push(Api.MarketPlaceBundle({ os: "web" }));
      }
      const [{ data }, banner, bundle] = await Promise.all(promiseArr);

      if (
        banner &&
        banner.data &&
        banner.data.Marketplace &&
        banner.data.Marketplace.length
      ) {
        let bannerImages = banner.data.Marketplace.map((b) => {
          return {
            web_banner_url: !isMobile ? b.web_banner_url : b.banner_url,
            vendor_web_path: b.vendor_web_path,
            deep_link_url: b.deep_link_url,
          };
        });
        bannerImages = bannerImages.filter(
          (ele) => ele.web_banner_url !== null
        );
        setBrandImage(bannerImages);
      }
      if (bundle?.data) {
        setBundleData(bundle.data);
      }
      if (data && data.results && data.results.length) {
        if (!searchFlow) {
          setBrandData([...brandData, ...data.results]);
          if (!data.next) {
            setHasMore(false);
          } else {
            setHasMore(true);
          }
          setPage(page + 1);
        } else {
          if (!data.next) {
            setHasMore(false);
          } else {
            setHasMore(true);
          }
          setBrandData([...data.results]);
        }
      } else {
        if (!data?.next) {
          setHasMore(false);
        }
        setBrandData([]);
      }
    } catch (err) {
      console.log("=======err==========", err);
      setError(true);
    }
    setLoading(false);
  };
  const sliderRef = useRef(null);
  sliderRef.current?.slickGoTo(slideNumber);
  const ExploreMarketPlace = () => {
    setSearchValue("");
    if (isMobile) {
      toggleMobSearch();
    }
  };
  useEffect(() => {
    UTMTracker.captureUTMParams();
    fetchMarketPlaceData(20);
    fetchSections();
  }, []);

  useEffect(() => {
    if (brandImage && brandImage.length) {
      const callEveryInterval = setTimeout(() => {
        setSlideNumbar((pre_slide) => (pre_slide + 1) % brandImage.length);
      }, 5000);
      return () => {
        clearTimeout(callEveryInterval);
      };
    }
  });

  const bundleView = () => {
    return bundleData.map((b) => {
      return (
        <BundleMarketCard
          key={b.id}
          plan={{
            planName: b.name,
            mrp_price: b.mrp_price,
            category: b.new_discount_percentage,
            max_coin_usable: b.max_coin_usable,
            discounted_cost: b.discounted_cost,
            image: b.plan_images_list,
            id: b.id,
            color: b.details?.colour_code,
            bundle_web_path: b.bundle_web_path,
          }}
        />
      );
    });
  };
  useEffect(() => {
    fetchMarketPlaceData(20, "search");
  }, [searchValue]);

  const handleNavigation = (path) => {
    UTMTracker.navigateWithParams(navigate, path);
  };

  const fetchSections = async () => {
    try {
      const { data } = await Api.GetSectionsList();
      if (data) {
        // Sort sections by order_of_display
        const sortedSections = data.sort((a, b) => a.order_of_display - b.order_of_display);
        setSectionsList(sortedSections.filter(section => section.is_active));
        
        // Fetch data for each section
        sortedSections.forEach(section => {
          fetchSectionData(section.id);
        });
      }
    } catch (err) {
      console.error("Error fetching sections:", err);
    }
  };

  const fetchSectionData = async (sectionId) => {
    try {
      setSectionsLoading(prev => ({ ...prev, [sectionId]: true }));
      const { data } = await Api.GetSectionData({ section_id: sectionId, os: 'web' });
      if (data) {
        setSectionsData(prev => ({
          ...prev,
          [sectionId]: data
        }));
      }
    } catch (err) {
      console.error(`Error fetching section ${sectionId} data:`, err);
    } finally {
      setSectionsLoading(prev => ({ ...prev, [sectionId]: false }));
    }
  };

  const renderSectionSkeleton = () => {
    return (
      <div className={styles.sectionSkeleton}>
        {[1, 2, 3, 4, 5, 6, 7, 8].map((_, idx) => (
          <div key={idx} className={styles.logoSkeletonCard}>
            <div className={styles.logoSkeletonWrapper}></div>
            <div className={styles.logoSkeletonText}></div>
            <div className={styles.logoSkeletonPrice}></div>
          </div>
        ))}
      </div>
    );
  };

  const renderSection = (sectionId) => {
    const sectionData = sectionsData[sectionId];
    const sectionDetails = sectionsList.find(s => s.id === sectionId);
    const isLoading = sectionsLoading[sectionId];
    
    if (!sectionDetails) return null;
    
    // Check if there's data to show in the section
    if (!isLoading && (!sectionData || sectionData.length === 0)) {
      return null; // Don't render the section if there's no data
    }
    
    return (
      <div key={sectionId} className={styles.sectionWrapper}>
        <div className={styles.BundleExploreContainer}>
          <p className={styles.sectionTitle}>{sectionDetails.name}</p>
          {sectionDetails.see_all_cta && sectionDetails.cta_text && (
            <p 
              onClick={() => handleNavigation(sectionDetails.deeplink_url || '/')} 
              className={styles.sectionSeeAll}
            >
              {sectionDetails.cta_text || 'SEE ALL'}
            </p>
          )}
        </div>
        {sectionDetails.subheading && (
          <p className={styles.sectionSubTitle}>{sectionDetails.subheading}</p>
        )}
        
        {isLoading ? (
          renderSectionSkeleton()
        ) : (
          <div className={styles.sectionScrollContainer}>
            {sectionData?.map((item, index) => (
              <SectionCard 
                key={`${item.vendor.vendor_id}-${index}`} 
                data={item.vendor} 
              />
            ))}
          </div>
        )}
      </div>
    );
  };

  // Skeleton loader that matches MarketPlaceCard layout
  const InfiniteScrollLoader = ({ count = 8 }) => {
    return (
      <div className={styles.skeletonLoader}>
        {Array(count).fill(0).map((_, index) => (
          <div key={`skeleton-${index}`} className={styles.skeletonCard}>
            <div className={styles.skeletonImage}></div>
            <div className={styles.skeletonContent}>
              <div className={styles.skeletonLogo}></div>
              <div className={styles.skeletonDetail}>
                <div className={styles.skeletonText}></div>
                <div className={styles.skeletonPrice}></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  // Skeleton loader for Marketplace
  const MarketplaceSkeleton = () => {
    return (
      <div className={styles.marketplace}>
        {/* Banner Skeleton */}
        <div className={styles.headcontent}>
          <div className={styles.bannerSkeleton}></div>
          <div className={styles.dotContainerSkeleton}>
            {[1, 2, 3, 4].map((_, idx) => (
              <div key={idx} className={styles.dotSkeleton}></div>
            ))}
          </div>
        </div>

        <div className={styles.restContent}>
          {/* Bundle Section Skeleton */}
          <div className={styles.skeletonSectionContainer}>
            <div className={styles.skeletonHeader}>
              <div className={styles.skeletonHeaderTitle}></div>
              <div className={styles.skeletonHeaderCta}></div>
            </div>
            <div className={styles.skeletonSubtitle}></div>
            <div className={styles.skeletonBundleScroll}>
              {[1, 2, 3, 4].map((_, idx) => (
                <div key={idx} className={styles.skeletonBundleCard}>
                  <div className={styles.skeletonBundleImage}></div>
                  <div className={styles.skeletonBundleContent}>
                    <div className={styles.skeletonBundleTitle}></div>
                    <div className={styles.skeletonBundlePrice}></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* First Dynamic Section Skeleton */}
          <div className={styles.skeletonSectionContainer}>
            <div className={styles.skeletonHeader}>
              <div className={styles.skeletonHeaderTitle}></div>
              <div className={styles.skeletonHeaderCta}></div>
            </div>
            <div className={styles.sectionSkeleton}>
              {[1, 2, 3, 4, 5, 6].map((_, idx) => (
                <div key={idx} className={styles.sectionCardSkeleton}>
                  <div className={styles.sectionImageSkeleton}></div>
                  <div className={styles.sectionContentSkeleton}>
                    <div className={styles.sectionLogoSkeleton}></div>
                    <div className={styles.sectionTextSkeleton}>
                      <div className={styles.sectionTitleSkeleton}></div>
                      <div className={styles.sectionPriceSkeleton}></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Second Dynamic Section Skeleton */}
          <div className={styles.skeletonSectionContainer}>
            <div className={styles.skeletonHeader}>
              <div className={styles.skeletonHeaderTitle}></div>
              <div className={styles.skeletonHeaderCta}></div>
            </div>
            <div className={styles.sectionSkeleton}>
              {[1, 2, 3, 4, 5, 6].map((_, idx) => (
                <div key={idx} className={styles.sectionCardSkeleton}>
                  <div className={styles.sectionImageSkeleton}></div>
                  <div className={styles.sectionContentSkeleton}>
                    <div className={styles.sectionLogoSkeleton}></div>
                    <div className={styles.sectionTextSkeleton}>
                      <div className={styles.sectionTitleSkeleton}></div>
                      <div className={styles.sectionPriceSkeleton}></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Search Bar Skeleton */}
          <div className={styles.tempSearchContainerSkeleton}>
            <div className={styles.skeletonHeaderTitle}></div>
            <div className={styles.searchBarSkeleton}></div>
          </div>

          {/* Explore All Brands Skeleton Grid */}
          <div className={styles.skeletonLoader}>
            {Array(8).fill(0).map((_, index) => (
              <div key={`skeleton-${index}`} className={styles.skeletonCard}>
                <div className={styles.skeletonImage}></div>
                <div className={styles.skeletonContent}>
                  <div className={styles.skeletonLogo}></div>
                  <div className={styles.skeletonDetail}>
                    <div className={styles.skeletonText}></div>
                    <div className={styles.skeletonPrice}></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  if (hasError) {
    return <ErrorFallback />;
  }
  if (loading) {
    return <MarketplaceSkeleton />;
  }

  return (
    <div className={styles.marketplace}>
      {isMobile && <NavBar fixedNavBar={true} isLoggedIn={isLoggedIn} />}

      <div className={styles.headcontent}>
        <div className={styles.sliderWrapper}>
          {brandImage && brandImage.length ? (
            <Slider ref={sliderRef} {...settings}>
              {brandImage.map((ele, idx) => (
                <a
                  href={
                    ele.deep_link_url
                      ? ele.deep_link_url
                      : `/brand/${ele.vendor_web_path}`
                  }
                  target={ele.deep_link_url ? "_blank" : ""}
                  onClick={() => {
                    if (ele.deep_link_url) {
                      // If deep_link_url exists, prevent the default behavior of the link
                      // to prevent the page from navigating twice (once with window.open and once with navigate)
                      window.open(ele.deep_link_url, "_blank");
                    } else if (ele.vendor_web_path) {
                      // If deep_link_url doesn't exist but vendor_web_path exists, use navigate
                      handleNavigation(`/brand/${ele.vendor_web_path}`);
                    }
                  }}
                >
                  <img
                    key={idx}
                    className={styles.bannerImage}
                    alt="bannerImage"
                    src={ele.web_banner_url}
                  />
                </a>
              ))}
            </Slider>
          ) : (
            ""
          )}
        </div>
        <div className={styles.dotContainer}>
          {brandImage.map((_, idx) => (
            <div
              key={idx}
              onClick={() => {
                setSlideNumbar(idx);
              }}
              className={
                idx === slideNumber ? cx(styles.dot, styles.active) : styles.dot
              }
            ></div>
          ))}
        </div>
      </div>
      {/* <div className={styles.restContent}>
                
            </div> */}


      <div className={styles.restContent}>
        {bundleData && bundleData.length > 0 && (
          <>
            <div className={styles.BundleExploreContainer}>
              <p className={styles.sectionTitle}>Exclusive bundles on Fleek 🤑</p>
              <p
                onClick={() => handleNavigation("/bundle")}
                className={styles.sectionSeeAll}
              >
                SEE ALL
              </p>
            </div>
            <p className={styles.sectionSubTitle}>Buy more for less</p>
            <ScrollMenu>{bundleView()}</ScrollMenu>
          </>
        )}

        {/* Render dynamic sections */}
        {sectionsList.map(section => renderSection(section.id))}

        <div className={styles.scrollHoriBorder}>
          <div className={styles.scrollHori}>
          </div>
        </div>

        <div className={styles.tempSearchContainer}>
          {!showMobileSearch && (
            <p className={styles.sectionTitle}>Explore all brands</p>
          )}
          <SearchComp
            showMobileSearch={showMobileSearch}
            toggleMobSearch={toggleMobSearch}
            setSearchValue={setSearchValue}
            searchValue={searchValue}
          />
        </div>
        <InfiniteScroll
          dataLength={brandData.length} //This is important field to render the next data
          next={fetchMarketPlaceData}
          hasMore={hasMore}
          loader={<InfiniteScrollLoader count={8} />}
          endMessage={
            <p style={{ textAlign: "center", marginTop: "20px", color: "#808080" }}>
              That's all the brands we have!
            </p>
          }
          refreshFunction={() => brandData}
          pullDownToRefresh
          pullDownToRefreshThreshold={20}
        >
          <div
            className={
              brandData.length ? styles.cardContainer : styles.noResultContainer
            }
          >
            {brandData.length ? (
              brandData.map((d) => {
                return <MarketPlaceCard data={d} key={d.vendor_id} />;
              })
            ) : (
              <div className={styles.container1}>
                <img
                  src={NoSearchResult}
                  alt="NoSearchResult"
                  className={styles.NoSearchResult}
                />
                <p className={styles.noResult}>No results found!</p>
                <button onClick={ExploreMarketPlace} className={styles.button1}>
                  EXPLORE MARKETPLACE
                </button>
              </div>
            )}
          </div>
        </InfiniteScroll>
      </div>
      <div className={styles.spacer}></div>
      {/* <MobileBottomNavBar isLoggedIn={isLoggedIn} type={"marketPlace"} /> */}
    </div>
  );
};
